<template>
    <div style="display: flex; flex-wrap: wrap;margin:4px auto 4px auto;">
        <div style="display:flex;justify-content:center;" v-if="item.thumbPath!==null" class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
                <img class="img-responsive" :src="item.thumbPath" :title="item.title">
        </div>

        <div class="col-xs-12" :class="{'col-sm-12 col-md-8 col-lg-9':item.thumbPath!==null}" style="display: flex; position: relative; flex-direction: column; justify-content:end; ">
                <div style="display: inline-block;text-align:left;">
                    <div v-if="item.textMsg!==null && item.textMsg!==''">
                        <div>
                            {{item.title}}
                        </div>
                        <div style="white-space:pre-line;"> {{item.textMsg}} </div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>

    export default {
        components: {

        },
        filters: {
           
        },
        props: ["item", "itemType"],
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>